import { useMemo } from "react";

import { normal } from "color-blend";

import { useTheme } from "../../../context/theme";
import { BACKGROUND_OVERLAY_OPACITY } from "../consts";
import {
  baseColorHexToRGBA,
  overlayColorHexToRGBA,
  RGBAToHex,
  RGBAToString
} from "../utils";

export type BackgroundColorFormat = "HEX" | "RGBA";

export default function useBackgroundColor(
  format: BackgroundColorFormat = "RGBA"
): string {
  const theme = useTheme();

  const backgroundColor = useMemo(() => {
    const baseColorRGBA = baseColorHexToRGBA(theme["background-base"]);

    const overlayColorRGBA = overlayColorHexToRGBA(
      theme["background-overlay"],
      BACKGROUND_OVERLAY_OPACITY
    );

    const blendRGBA = normal(baseColorRGBA, overlayColorRGBA);

    return format === "RGBA" ? RGBAToString(blendRGBA) : RGBAToHex(blendRGBA);
  }, [format, theme]);

  return backgroundColor;
}
